import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {Spinner} from 'react-bootstrap';
import {useTableAPI} from 'hooks';
import Pagination from 'shared/components/Table/Pagination';
import {JobCard} from './JobCard';
import type {JobCardListProps} from './types';

export const JobCardListAPI = ({
    title,
    tableOption,
    link,
    headerAction,
}: JobCardListProps) => {
    const {fields, options: buttonsConfig} = tableOption;
    const {records, pagination, setPage} = useTableAPI(tableOption);

    useEffect(() => {
        if (
            typeof tableOption.after !== 'undefined' &&
            typeof records !== 'undefined'
        ) {
            tableOption.after(records);
        }
    }, [records]);

    return (
        <div className="job-card-list">
            <div className="job-card-list-header">
                <h2>{title}</h2>
                {headerAction}
            </div>

            {typeof records === 'undefined' ? (
                <div className="job-card-list-loading">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : records.length ? (
                records.map((row) => (
                    <JobCard
                        key={row.id}
                        row={row}
                        fields={fields}
                        buttonsConfig={buttonsConfig}
                    />
                ))
            ) : (
                <p className="job-card-list-empty">
                    {tableOption.noRecordsText || 'No records.'}
                </p>
            )}

            {typeof tableOption.pagination !== 'undefined' &&
            typeof records !== 'undefined' &&
            records.length > 0 ? (
                <div className="job-card-list-pagination">
                    <Pagination pagination={pagination} setPage={setPage} />
                </div>
            ) : null}

            {link ? (
                <Link className="job-card-list-more" to={link}>
                    See more
                </Link>
            ) : null}
        </div>
    );
};
